// Extracted from web/App.tsx; behavior and declaration bodies preserved.
import { useState } from "react";
import { Button, Field, Modal, Notice, errorText } from "../components/Primitives";

export function RepositoryDialog({
  onClose,
  onCreate,
}: {
  onClose: () => void;
  onCreate: (data: any) => Promise<void>;
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  return (
    <Modal
      title="Create a repository"
      subtitle="Keep related models together within your studio."
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="primary"
            disabled={!name.trim()}
            busy={busy}
            onClick={async () => {
              setBusy(true);
              try {
                await onCreate({
                  name,
                  description,
                  mapping: { kind: "unmapped" },
                });
              } catch (e) {
                setError(errorText(e));
                setBusy(false);
              }
            }}
          >
            Create repository
          </Button>
        </>
      }
    >
      <Field label="Repository name">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Enterprise architecture"
        />
      </Field>
      <Field label="Description">
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
        />
      </Field>
      {error && <Notice kind="error">{error}</Notice>}
    </Modal>
  );
}
